export function Home() {
    return (<svg viewBox="0 0 21 21"><g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><path d="M1.5 10.5l9-9l9 9"></path><path d="M3.5 11.5v4a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4"></path></g></svg>)
}
